import { Icon } from "@iconify/react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  addDoc,
  collection,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../Firebase/Config";
import RouteWithTitle from "../../Layout/RouteWithTitle";
import Showmodal from "../ShowModal/ShowModal";
import Loading from "../../Home-Page/Main/Loading/Loading";

function Showabout() {
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [newData, setNewData] = useState({});
  const [currentItem, setCurrentItem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const onSubmit = async (newInformation) => {
    try {
      const ref = collection(db, "about");

      const snapshot = await getDocs(ref);
      const Id = snapshot.size + 1;
      newInformation.Id = Id;

      await addDoc(ref, newInformation);
      navigate("/admin/create/about");
    } catch (error) {
      console.error(error);
    }
  };

  const onUpdate = async (id, newInformation) => {
    try {
      debugger;
      await setDoc(doc(db, "about", id), newInformation);
      navigate("/admin/create/about");
    } catch (error) {
      console.error(error);
    }
  };

  const onEdit = async (id, newData) => {
    setCurrentItem(id);
    setShowModal(true);
    try {
      await setDoc(doc(db, "about", id), newData);
      setNewData(
        data.map((item) =>
          item.id === id ? { ...item, ...item, ...newData } : item
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  const onDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "about", id.toString()));
      setData(data.filter((item) => item.id !== id));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setLoading(true);
    const ref = collection(db, "about");
    getDocs(ref).then((snapshot) => {
      if (snapshot.empty) {
        setError("خطایی رخ داد");
        setLoading(false);
      } else {
        setLoading(false);
        const unsubscribe = onSnapshot(ref, (snapshot) => {
          let result = [];
          snapshot.docs.forEach((doc) => {
            result.push({ id: doc.id, ...doc.data() });
          });
          setData(result);
        });
        return () => unsubscribe();
      }
    });
  }, []);

  return (
    <>
    <RouteWithTitle>
      <div className="flex flex-col bg-slate-700 h-full p-5 overflow-y-scroll text-white">
        <div className="flex pb-5">
          <Showmodal
            hiddenPicture
            hiddenHref
            hiddenDescription
            title={"درباره من"}
            button={"ایجاد مهارت"}
            onSubmit={onSubmit}
          />
        </div>
        <div className="flex">
          <table className="w-full">
            <thead>
              <tr>
                <th className="p-2">تعداد</th>
                <th className="p-2">تیتر</th>
                <th className="p-2">اندازه</th>
                <th className="p-2">ویرایش</th>
                <th className="p-2">پاک کردن</th>
              </tr>
            </thead>
            <tbody>
              {error ? (
                error
              ) : loading ? (
                <tr>
                  <td>
                    <Loading />
                  </td>
                </tr>
              ) : data ? (
                data
                  .sort((a, b) => a.Id - b.Id)
                  .map((item) => (
                    <tr key={item.Id}>
                      <th className="border p-2">{item.Id}</th>
                      <td className="border p-2">{item.Title}</td>
                      <td className="border p-2">{item.Size}%</td>
                      <td className="border p-2">
                        <Icon
                          icon="mingcute:edit-line"
                          wirth="30"
                          height="30"
                          className="cursor-pointer mr-2 mt-1"
                          onClick={() => {
                            onEdit(item.id);
                          }}
                        />
                      </td>
                      <td className="border p-2">
                        <Icon
                          icon="mingcute:delete-line"
                          wirth="30"
                          height="30"
                          className="cursor-pointer mr-2 mt-1"
                          onClick={() => onDelete(item.id)}
                        />
                      </td>
                      <td>
                        {showModal && currentItem === item.id && (
                          <Showmodal
                            button={"ویرایش آیتم"}
                            hiddenPicture
                            hiddenHref
                            hiddenDescription
                            onClick={() => {
                              onEdit(item.id, newData);
                            }}
                            onUpdate={() => {
                              onUpdate(item.id);
                            }}
                          />
                        )}
                      </td>
                    </tr>
                  ))
              ) : (
                <tr>
                  <td>
                    <p>داده‌ای وجود ندارد</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      </RouteWithTitle>
    </>
  );
}

export default Showabout;